import { Select, Stack } from "@mantine/core";
import { useState } from "react";
import { client } from "@/api-client";
import type { SessionWithTrainerDisplayListOutput } from "@/api-types";
import { FancyLoader } from "@/components/FancyLoader";
import { Header } from "@/components/Header";
import { SessionCard } from "@/components/SessionCard";
import { isSessionCancelled } from "@/components/SessionUtils";

export const SessionList = () => {
  const [filter, setFilter] = useState<string>("all");

  const { data: sessionList, isLoading } = client.useQuery(
    "get",
    "/owner/sessions/",
  );

  if (isLoading || !sessionList) {
    return <FancyLoader />;
  }

  const filterSessions = (sessions: SessionWithTrainerDisplayListOutput[]) => {
    let filtered: SessionWithTrainerDisplayListOutput[] = [];

    if (filter === "future") {
      filtered = sessions.filter((session) => session.status === "CONFIRMED");
    } else if (filter === "past") {
      filtered = sessions.filter((session) => session.status === "COMPLETED");
    } else if (filter === "cancelled") {
      filtered = sessions.filter((session) =>
        isSessionCancelled(session.status),
      );
    } else if (filter === "all") {
      filtered = sessions.filter(
        (session) =>
          session.status === "REQUESTED" ||
          session.status === "CONFIRMED" ||
          session.status === "COMPLETED",
      );
    }

    return filtered;
  };

  const filteredSessions = filterSessions(sessionList.sessions);

  return (
    <Stack>
      <Header title="Sessions" />
      <Select
        value={filter}
        onChange={(value) => value && setFilter(value)}
        data={[
          { value: "all", label: "All Sessions" },
          { value: "future", label: "Future Sessions" },
          { value: "past", label: "Past Sessions" },
          { value: "cancelled", label: "Cancelled Sessions" },
        ]}
      />

      {filteredSessions.map((session) => (
        <SessionCard key={session.id} session={session} who="owner" />
      ))}
    </Stack>
  );
};
